var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrivateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.666,
    height: 50,
    viewBox: "0 0 41.666 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "shield-check",
    d: "M36.543,4.459,23.491.107a2.083,2.083,0,0,0-1.317,0L9.123,4.459A10.4,10.4,0,0,0,2,14.34V25C2,40.756,21.166,49.458,21.987,49.821a2.083,2.083,0,0,0,1.692,0C24.5,49.458,43.666,40.756,43.666,25V14.34a10.4,10.4,0,0,0-7.123-9.881ZM32.662,20.244l-8.9,8.9A3.9,3.9,0,0,1,20.981,30.3h-.069a3.9,3.9,0,0,1-2.8-1.25l-4.8-5a2.083,2.083,0,1,1,3-2.879l4.675,4.875,8.725-8.75a2.083,2.083,0,1,1,2.946,2.946Z",
    transform: "translate(-2)",
    fill: "#3db6fb"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivateIcon);
export default __webpack_public_path__ + "static/media/private_icon.fcf1dfb02de8f557913b267f18dbc28a.svg";
export { ForwardRef as ReactComponent };